import React, { Component } from 'react'

import { connect } from 'react-redux'
import { PanelGroup, Panel, Grid } from 'react-bootstrap'

import AddClient from './components/AddClient'
import PromoteDemoteUser from './components/PromoteDemoteUser'
import ManageMetadataTypes from './components/ManageMetadataTypes'
import ManageMetadataValues from './components/ManageMetadataValues'
import AddUsers from './components/AddUsers'
import EditUserClients from './components/EditUserClients'
import EditUserRoleAndTeam from './components/EditUserRoleAndTeam'
import AddOrEditSimpleInstance from './components/AddOrEditSimpleInstance'
import EditUserWorkloadStatus from './components/EditUserWorkloadStatus'
import ActivateDeactivateUsers from './components/ActivateDeactivateUsers'

import AuthenticationComponent from '../../AuthenticationComponent';

import {
  getUsers, getClients, getRoles, getTeams, addRole, addTeam, editRole, editTeam } from '../login/reducers/manageLogin'
import { getMetadata } from '../projects/reducers/manageProjects'
import { getProposalMetadata } from '../proposals/reducers/manageProposals'


import './style.css'

class ManagerContainer extends Component {

  componentDidMount() {
    this.props.getMetadata()
    this.props.getProposalMetadata()
    this.props.getUsers()
    this.props.getClients()
    this.props.getRoles()
    this.props.getTeams()
  }

  render () {
    const { currentUser } = this.props

    const commonAddOrEditRolesProps = {
      options: this.props.roles,
      route:"roles",
      formFields: ['name'],
      displayNameSingular: "Role",
      displayNamePlural:"Roles",
      labelKey: (option) => option.name,
    }

    const commonAddOrEditTeamsProps = {
      options: this.props.teams,
      route: "teams",
      formFields: ['name', 'subgroup'],
      displayNameSingular: "Team",
      displayNamePlural: "Teams",
      labelKey: (option) => {
        if (option.subgroup) {
          return `${option.name} - ${option.subgroup}`
        }
        return option.name
      },
    }

    const fetchingData = this.props.fetchingMetadata || this.props.fetchingProposalMetadata || this.props.fetchingRoles
      || this.props.fetchingTeams

    if (fetchingData) {
      return (
        <center>
          <h4> Loading... </h4>
          <img alt="loader" src={require("../../static/images/spinner.gif")} />
        </center>
      )
    } else {

      const teamsThatCanEditWorkloadStatus = ['digital solutions', 'executive']

      const userCanEditEmployeeWorkloadStatus = currentUser && currentUser.team && currentUser.team.name && teamsThatCanEditWorkloadStatus.includes(currentUser.team.name.toLowerCase())

      return (
        <div id="ManagerContainer">
          <AuthenticationComponent />
          <br/>
          <br/>
          {this.props.currentUser.is_manager ?
            <Grid>
              <PanelGroup
                accordion
                id="accordion-controlled"
                >
                <Panel eventKey="1">
                  <Panel.Heading>
                    <Panel.Title toggle>
                      Manage Metadata
                    </Panel.Title>
                  </Panel.Heading>
                  <Panel.Body collapsible>
                    <ManageMetadataTypes />
                  </Panel.Body>
                </Panel>

                <Panel eventKey="2">
                  <Panel.Heading>
                    <Panel.Title toggle>
                      Manage Metadata Values
                    </Panel.Title>
                  </Panel.Heading>
                  <Panel.Body collapsible>
                    <ManageMetadataValues />
                  </Panel.Body>
                </Panel>

                <Panel eventKey="3">
                  <Panel.Heading>
                    <Panel.Title toggle>
                      Add Clients
                    </Panel.Title>
                  </Panel.Heading>
                  <Panel.Body collapsible>
                    <AddClient />
                  </Panel.Body>
                </Panel>

                <Panel eventKey="4">
                  <Panel.Heading>
                    <Panel.Title toggle>
                      Add Users
                    </Panel.Title>
                  </Panel.Heading>
                  <Panel.Body collapsible>
                    <AddUsers />
                  </Panel.Body>
                </Panel>

                <Panel eventKey="5">
                  <Panel.Heading>
                    <Panel.Title toggle>
                      Add or Edit Roles
                    </Panel.Title>
                  </Panel.Heading>
                  <Panel.Body collapsible>
                    <AddOrEditSimpleInstance 
                      {...commonAddOrEditRolesProps}
                      method="POST"
                      handleSaveSuccess={this.props.addRole}     
                    />
                    <hr />
                    <AddOrEditSimpleInstance 
                      {...commonAddOrEditRolesProps}
                      method="PATCH"
                      handleSaveSuccess={this.props.editRole} 
                    />
                  </Panel.Body>
                </Panel>

                <Panel eventKey="6">
                  <Panel.Heading>
                    <Panel.Title toggle>
                      Add or Edit Teams
                    </Panel.Title>
                  </Panel.Heading>
                  <Panel.Body collapsible>
                    <AddOrEditSimpleInstance 
                      {...commonAddOrEditTeamsProps}
                      method="POST"
                      handleSaveSuccess={this.props.addTeam}
                    />
                    <hr />
                    <AddOrEditSimpleInstance 
                      {...commonAddOrEditTeamsProps}
                      method="PATCH"
                      handleSaveSuccess={this.props.editTeam} 
                    />
                  </Panel.Body>
                </Panel>

                <Panel eventKey="7">
                  <Panel.Heading>
                    <Panel.Title toggle>
                      Edit User Clients
                    </Panel.Title>
                  </Panel.Heading>
                  <Panel.Body collapsible>
                    <EditUserClients />
                  </Panel.Body>
                </Panel>

                <Panel eventKey="8">
                  <Panel.Heading>
                    <Panel.Title toggle>
                      Edit User Role And Team
                    </Panel.Title>
                  </Panel.Heading>
                  <Panel.Body collapsible>
                    <EditUserRoleAndTeam />
                  </Panel.Body>
                </Panel>

                <Panel eventKey="9">
                  <Panel.Heading>
                    <Panel.Title toggle>
                      Promote or Demote a User
                    </Panel.Title>
                  </Panel.Heading>
                  <Panel.Body collapsible>
                    <PromoteDemoteUser />
                  </Panel.Body>
                </Panel>

                {userCanEditEmployeeWorkloadStatus ?
                  <Panel eventKey="10">
                    <Panel.Heading>
                      <Panel.Title toggle>
                        Modify Employee Workload Tracker Status
                      </Panel.Title>
                    </Panel.Heading>
                    <Panel.Body collapsible>
                      <EditUserWorkloadStatus
                        users={this.props.users}
                      />
                    </Panel.Body>
                  </Panel>
                  :
                  null
                }

                {currentUser.is_superuser ?
                  <Panel eventKey="11">
                    <Panel.Heading>
                      <Panel.Title toggle>
                        Activate/Deactivate Users
                      </Panel.Title>
                    </Panel.Heading>
                    <Panel.Body collapsible>
                      <ActivateDeactivateUsers />
                    </Panel.Body>
                  </Panel>
                  :
                  null
                }

              </PanelGroup>
            </Grid>
            :
            null
          }
        </div>
      )
    }
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.manageLogin.user,
    fetchingMetadata: state.manageProjects.fetchingMetadata,
    fetchingProposalMetadata: state.manageProposals.fetchingProposalMetadata,
    fetchingRoles: state.manageLogin.fetchingRoles,
    fetchingTeams: state.manageLogin.fetchingTeams,
    roles: state.manageLogin.roles,
    teams: state.manageLogin.teams,
    users: state.manageLogin.users,
  }
}

const mapDispatchToProps = { 
  getUsers, 
  getClients, 
  getRoles, 
  getTeams, 
  addRole,
  addTeam,
  editRole, 
  editTeam,
  getMetadata, 
  getProposalMetadata, 
}

export default connect(mapStateToProps, mapDispatchToProps)(ManagerContainer);



// WEBPACK FOOTER //
// ./src/routes/manager/ManagerContainer.js